import React, { useState } from "react";
import * as style from "./styles.mod.scss";
import { Container } from "react-bootstrap";
import { Formik, Field, Form } from "formik";
import Logo from "assets/svgs/O-Logo.svg";
import locale from "locales";
import Countdown from "../countdown-banner/countdown";
import { Link } from "gatsby";

const PrivateSale = ({ privateSale, passwordEntered, setPasswordEntered, timer }) => {
  const [error, setError] = useState("");

  const handleSubmit = (values, { setFieldValue }) => {
    if (values.password !== privateSale.privateSalePassword) {
      setError("Wrong Password, try again");
      setFieldValue("password", "");
    } else {
      localStorage.setItem("privateSalePassword", values.password);
      setPasswordEntered(!passwordEntered);
      setError("");
    }
  };

  return (
    <div className={style.privateSaleContainer}>
      <Container className={style.formContainer}>
        <Logo />
        <div className={style.privateSaleCountdown}>
          <Countdown timer={timer} />
        </div>
        <h2>{locale.privateSale.welcome}</h2>
        <h5>{locale.privateSale.promotion}</h5>
        <Formik
          initialValues={{ password: "" }}
          onSubmit={handleSubmit}
        >
          {({ handleChange }) => (
            <Form className={style.emailButtonContainer}>
              <Field
                type="password"
                onChange={handleChange}
                className={style.email}
                name="password"
                placeholder="Passwort eingeben"
              />
              <button type="submit" className={style.submitButton}>
                <p>{locale.privateSale.enterSale}</p>
              </button>
            </Form>
          )}
        </Formik>
        {error && <p className={style.errorMessage}>{error}</p>}
        <p className={style.linkSignUp}>{locale.privateSale.lastMinute}<span><Link to="/private-sale-sign-up" className={style.coloredText}> Hier</Link></span> klicken.</p>
      </Container>
    </div>
  );
};

export default PrivateSale;
